import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EntertainmentService {
  constructor(private http: HttpClient,private header: HttpHeadersService) {
  }

  getTVEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/tv_settings/get_tv_settings`, payload, { headers }).toPromise();
  }

  postTVSetting(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/tv_settings/publish_tv_settings`, payload, { headers }).toPromise();
  }

  getIPTVEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/iptv_settings/get_iptv_settings`, payload, { headers }).toPromise();
  }

	postIPTVSetting(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/iptv_settings/publish_iptv_settings`, payload, { headers }).toPromise();
  }

  getAppsEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/product_settings/apps/get`, payload, { headers }).toPromise();
  }

  postAppsEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/product_settings/apps/publish`, payload, { headers }).toPromise();
  }

  getInternetEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/internet_settings/get_internet_settings`, payload, { headers }).toPromise();
  }

  postInternetEntertainmentData(payload: any) {
    const headers = this.header.bearerHttpAuthorizationHeader();
    return this.http.post(`${environment.servicePath}/internet_settings/publish_internet_settings`, payload, { headers }).toPromise();
  }

}

